import { Controller } from "stimulus";

export default class extends Controller {
    
    static targets = ['form']

    connect(){
        this.preview = this.element.querySelector('.website-previewer iframe').contentWindow;
        this.setupTextUpdateListener('#news_title', '[data-preview=title]');
        this.setupTextUpdateListener('#news_text', '[data-preview=text]');
    }

    setupTextUpdateListener(inputSelector, targetSelector) {
        let input = this.element.querySelector(inputSelector)
        if (input) {
            input.addEventListener('input', (e) => {
                this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
            })

            input.addEventListener('trix-change', (e) => {
                this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
            })


            input.addEventListener('paste', (e) => {
                this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
            })

            input.addEventListener('change', (e) => {
                this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
            })
        }
    }


    async formSubmit(e) {
        e.preventDefault();
        const urlToObject = async(src, filename) => {
          const response = await fetch(src);
          const blob = await response.blob();
          console.log(blob);
          const file = new File([blob], filename, {type: blob.type});
          return file;
        }
        let container = new DataTransfer(); 
        let uploadedImages = document.getElementById("uploaded-images");
        var children = uploadedImages.querySelectorAll(".image-content");
        let position = {};
        let count = 0;

        for (const node of children) {
        const src = node.firstElementChild.src;
        const filename = node.getElementsByTagName('p')[0].innerText;
        if(node.firstElementChild.id == "pexel"){
            const result = await urlToObject(src, filename);
            container.items.add(result);
        }else if(node.firstElementChild.id != ""){
            position[count] = node.firstElementChild.id;
        }else{
            const result = this.dataURLtoFile(src, filename);
            container.items.add(result);
        }
        count++;
        }

        document.getElementById("position").value = JSON.stringify(position);
        let deletedImages = document.getElementById("deleted-image-ids");
        let arrayOfDeletedImages = deletedImages.value.split(",");
        arrayOfDeletedImages.pop();
        deletedImages.value = arrayOfDeletedImages;
        let images = document.getElementById("images");
        images.files = container.files;
        this.formTarget.submit();
    }

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);

        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type:mime});
    }
}